import type {
  RequestAirlineInfoInterface,
  ResponseAirlinesBySlugInterface,
} from "@/libs/server/goApiServer/airlines/getAirlineDetailBySlug";
import { ResponseAirlinesBySlugClass } from "@/libs/server/goApiServer/airlines/getAirlineDetailBySlug";
import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import {
  type RequestAirlinePopularInterface,
  ResponseAirlinesPopularInterface,
} from "./airlinesPopular";

class AirlinesServiceApi {
  private baseUrl: string;

  private basePath: string;

  private basePathV3: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v2/airline";
    this.basePathV3 = "v3/airline";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  async getAirlinesBySlug(
    param: RequestAirlineInfoInterface,
  ): Promise<ResponseAirlinesBySlugInterface> {
    const queryParams = new URLSearchParams(param as any);

    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePath}/AirlineBySlug?${queryParams}`,
      "GET",
      {},
      false,
      undefined,
      false,
    )) as any;
    return new ResponseAirlinesBySlugClass(response);
  }

  async getRouteAirlinePopular(param: RequestAirlinePopularInterface) {
    const queryParams = new URLSearchParams(param as any);

    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV3}/airlinePopular?${queryParams}`,
      "GET",
      {},
      false,
      undefined,
      false,
    )) as any;

    return new ResponseAirlinesPopularInterface(response);
  }
}

export default AirlinesServiceApi;
